import InfoSvg from "../../Svg/InfoSvg";
import constants from "../../constants";
import React, { useContext, useMemo, useState } from "react";
import IconButton from "@mui/material/IconButton";
import ScoreHooks from "../../Hooks/Score/ScoreHooks";
import AlertContext from "../../context/AlertContext";
import Popover from "../CommonComponents/Popover";
import StudentListHooks from "../../Hooks/StudentListHooks";

export default function Score() {
  const { testData, testDetail, showBreadCrumbsData } = useContext(AlertContext);
  const { toggleDrawerScore, getScore } = ScoreHooks();
  const { currentLearnerName } = StudentListHooks();

  const [anchorEl, setAnchorEl] = useState(null);
  
  
  const sections = useMemo(
    () => testDetail?.data?.sections || [],
    [testDetail]
  );

  let qnId = 0;

  return testDetail.libtypeid === constants.libTypeIds.SQL ? (
    <Popover
      buttonLabel={
        <div className="scoreMainContainer">
          <div className="scoreLabel">Score:</div>
          <div className="scoreValue">{getScore()}</div>
        </div>
      }
      anchorEl={anchorEl}
      setAnchorEl={setAnchorEl}
      trigger="hover"
      className="scorePopover"
      disableRestoreFocus
    >
      <div className="scoreInfoContent">
        <div className="scoreInfoHeader">
          <div className="scoreInfoTitle">
            <h3>{testDetail?.data?.testname ?? ""}</h3>
            <p>{currentLearnerName ?? ""}</p>
          </div>
        </div>
        <div className="scoreInfoBody">
          {sections.map((section, index) =>
            section?.questions?.map((question, qIndex) => {
              qnId++;
              return (
                <div
                  key={question.id || `q-${index}-${qIndex}`}
                  className="scoreInfoQuestion"
                >
                  <p className="scoreInfoQuestionText">
                    <span>Q{qnId}:</span> {question.actualscore ?? 0}/
                    {question.targetscore ?? 0}
                  </p>
                </div>
              );
            })
          )}
        </div>
      </div>
    </Popover>
  ) : (
    <div className="scoreMainContainer">
      <div className="scoreLabel">Score:</div>
      <div className="scoreValue">{getScore()}</div>
      <IconButton
        className="scoreInfoSvgIcon"
        onClick={toggleDrawerScore("right", true)}
      >
        {testDetail.libtypeid === constants.libTypeIds.CODING_CHALLENGE && (
          <InfoSvg />
        )}
      </IconButton>
    </div>
  );
}
